import { embeddedSessionNoticeColors } from '@tl4k/frontend-shared';

type Props = {
  message: string;
  onDismiss: () => void;
  testId?: string;
};

/**
 * Avviso NON bloccante sulla sessione (PIN di un'altra app, lavoro locale rimasto sul
 * dispositivo perche' la sessione aveva gia' un elaborato...). Si chiude a mano.
 * Pattern di Disegna, estratto per le altre app derivabili.
 */
export function EmbeddedSessionNoticeBar({ message, onDismiss, testId = 'session-notice' }: Props) {
  const colors = embeddedSessionNoticeColors('warning');
  return (
    <div
      role="alert"
      data-testid={testId}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flex: '0 0 auto',
        padding: '8px 14px',
        borderBottom: `1px solid ${colors.border}`,
        background: colors.background,
        color: colors.color,
        fontSize: 14,
      }}
    >
      <span style={{ flex: 1 }}>{message}</span>
      <button
        type="button"
        aria-label="Chiudi avviso"
        onClick={onDismiss}
        style={{
          minHeight: 32,
          padding: '0 12px',
          borderRadius: 8,
          border: '1px solid currentColor',
          background: 'transparent',
          color: 'inherit',
          fontWeight: 600,
        }}
      >
        Chiudi
      </button>
    </div>
  );
}
